import { render, staticRenderFns } from "./ManterGruposView.vue?vue&type=template&id=1eb0f33d&scoped=true&"
import script from "./ManterGruposView.vue?vue&type=script&lang=js&"
export * from "./ManterGruposView.vue?vue&type=script&lang=js&"
import style0 from "./ManterGruposView.vue?vue&type=style&index=0&id=1eb0f33d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb0f33d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VChipGroup,VCol,VContainer,VDataTable,VForm,VIcon,VRow,VTextField})
